export default __webpack_public_path__ + "static/media/25l_drybackpack.fea928f2.jpg";